import { Box, Button, ButtonGroup } from "@mui/material";
import { DATE_PRESETS } from "../constants";
import DateRangeFilter from "../../../../Components/DateRangeFilter";

interface DashboardFiltersProps {
  startDate: string;
  endDate: string;
  activePreset: number;
  onPresetChange: (days: number) => void;
  onDateChange: (start: string, end: string) => void;
}

const DashboardFilters = ({
  startDate,
  endDate,
  activePreset,
  onPresetChange,
  onDateChange,
}: DashboardFiltersProps) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
      <ButtonGroup size="small" variant="outlined">
        {DATE_PRESETS.map((preset) => (
          <Button
            key={preset.days}
            variant={activePreset === preset.days ? "contained" : "outlined"}
            onClick={() => onPresetChange(preset.days)}
            sx={{
              textTransform: "none",
              fontWeight: activePreset === preset.days ? 700 : 400,
              minWidth: 44,
              px: 1.5,
              fontSize: 13,
            }}
          >
            {preset.label}
          </Button>
        ))}
      </ButtonGroup>
      <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center", gap: 1 }}>
        <DateRangeFilter
          startDate={startDate}
          endDate={endDate}
          onChange={(key, value) => {
            if (key === "endDate") {
              onDateChange(startDate, value);
            } else {
              onDateChange(value, endDate);
            }
          }}
          label=""
        />
      </Box>
    </Box>
  );
};

export default DashboardFilters;
